export class NativeAppCallbackError extends Error {
  name = 'NATIVE_APP_CALLBACK_ERROR'

  constructor(fnName: string, message?: string) {
    super(`Native app callback ${fnName} received error: ${message}`)
  }
}
